"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorldpayServerCommonAPI = void 0;
const shared_1 = require("@getgreenline/shared");
class WorldpayServerCommonAPI {
    constructor(appSpecificHeaders) {
        this.getResourceFromLocation = async ({ requestId, tenantSpecificHeaders, resourceLocation, }) => {
            const res = await shared_1.axios.get(resourceLocation, {
                headers: this.getCommonHeaders(requestId, tenantSpecificHeaders),
            });
            if (res.status === 202) {
                const data = {
                    operationRetry: res.headers['operation-retry'],
                    resourceLocation: res.headers['resource-location'],
                };
                return {
                    statusCode: res.status,
                    data,
                };
            }
            return {
                statusCode: res.status,
                data: res.data,
            };
        };
        this.getCommonHeaders = (requestId, tenantSpecificHeaders) => {
            return {
                ...this.appSpecificHeaders,
                ...tenantSpecificHeaders,
                'tp-request-id': requestId,
                'Content-Type': 'application/json',
            };
        };
        this.throwError = (error) => {
            var _a;
            // There seem to be 2 types of errors, and I'm not sure what error returns in what format
            const worldpayError = error;
            const message = worldpayError.response ? this.createErrorMessage(worldpayError) : worldpayError;
            throw {
                statusCode: ((_a = worldpayError.response) === null || _a === void 0 ? void 0 : _a.status) || 500,
                message,
            };
        };
        this.createErrorMessage = (worldpayError) => {
            return Object.keys(worldpayError.response.data).includes('_hasErrors')
                ? worldpayError.response.data._errors
                    .map((_error) => _error.developerMessage)
                    .join('\n')
                : worldpayError.response.data.exceptionMessage;
        };
        this.appSpecificHeaders = appSpecificHeaders;
    }
}
exports.WorldpayServerCommonAPI = WorldpayServerCommonAPI;
//# sourceMappingURL=WorldpayServerCommonAPI.js.map